/* eslint-disable no-unused-expressions */

import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '../../FormElements/Checkbox';
import LockIcon from '../../../themes/svg/lockIcon';

const EstimateSelector = (props) => {
  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (props.isShared || props.isDisabled) return;
    props.isSelected ? props.removeEstimate(props.designId) : props.addDesign(props.designId);
  };

  return (
    <div
      className={`estimateSelector ${props.isSelected ? 'selected' : ''}`}
      role="button"
      tabIndex="-1"
      onClick={onClick}
    >
      <div className={`selector ${props.isDisabled ? 'disabledSelection' : ''}`}>
        {!props.isShared && (
          <Checkbox
            name={`checkbox-${props.designId}`}
            checked={props.isSelected}
            label={props.estimateName}
            className="truncateText"
          />
        )}
        {props.isShared && (
          <span className="locked">
            <div className="icon lockStyle">
              <LockIcon />
              <span className="truncateText" title={props.estimateName}>{` ${props.estimateName}`}</span>
            </div>
          </span>
        )}
      </div>
    </div>
  );
};

EstimateSelector.propTypes = {
  designId: PropTypes.string.isRequired,
  estimateName: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  addDesign: PropTypes.func.isRequired,
  removeEstimate: PropTypes.func.isRequired,
  isShared: PropTypes.bool.isRequired,
};

export default EstimateSelector;
